import script from "./ModalMapa.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMapa.vue?vue&type=script&setup=true&lang=js"

import "./ModalMapa.vue?vue&type=style&index=0&id=07800da6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07800da6"]])

export default __exports__